import { useQuery } from '@tanstack/react-query';
import { nanoid } from 'nanoid';
import { api } from '../api/client';
import type { ProgressUpdate } from '../types';

export function useProgressNotes(taskId: string) {
  const { data } = useQuery({
    queryKey: ['progress-updates', taskId],
    queryFn: () => api.progressUpdates.getByTaskId(taskId),
  });
  return (data ?? []) as ProgressUpdate[];
}

export function useAllProgressUpdates() {
  const { data } = useQuery({
    queryKey: ['progress-updates', 'all'],
    queryFn: () => api.progressUpdates.getAll(),
  });
  return (data ?? []) as ProgressUpdate[];
}

export async function addProgressNote(
  taskId: string,
  note: string,
  progressBefore: number,
  progressAfter: number
): Promise<ProgressUpdate> {
  const update = {
    id: nanoid(),
    taskId,
    note,
    progressBefore,
    progressAfter,
    createdAt: new Date().toISOString(),
  };
  await api.progressUpdates.create(update);
  return update;
}

export async function updateProgressNote(id: string, changes: Partial<ProgressUpdate>) {
  await api.progressUpdates.update(id, changes);
}

export async function deleteProgressNote(id: string) {
  await api.progressUpdates.delete(id);
}
